import { render, staticRenderFns } from "./modalProductosProvedores.vue?vue&type=template&id=d5a46ad0&scoped=true&"
import script from "./modalProductosProvedores.vue?vue&type=script&lang=js&"
export * from "./modalProductosProvedores.vue?vue&type=script&lang=js&"
import style0 from "./modalProductosProvedores.vue?vue&type=style&index=0&id=d5a46ad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a46ad0",
  null
  
)

export default component.exports